import * as React from 'react';
import { SVGProps } from 'react';

const FileIconUndefinedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      d="M16 10.64c0 .56-.027.98-.08 1.26-.053.267-.173.54-.36.82L13.04 15v2H11v-2.5l2.92-2.92c.053-.187.08-.44.08-.76v-.52c0-.413-.12-.733-.36-.96-.24-.227-.607-.34-1.1-.34H9V7h3.3c2.24 0 3.7 1 3.7 3v.64ZM13 19v2h-2v-2h2Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconUndefinedSizeS;
